<template>
    <div class="photo-viewer">
        <b-button :variant="buttonVariant"
                  size="sm"
                  :disabled="loading"
                  @click="showModal"
                  class="text-nowrap"
        >
            <slot name="text">
                Show Photos
            </slot>
            <span v-if="loading">
                <b-spinner small class="ml-2"></b-spinner>
                <span class="sr-only">Loading...</span>
            </span>
            <font-awesome-icon
                v-else
                class="ml-md-2"
                :icon="['far', 'camera']">
            </font-awesome-icon>
        </b-button>
        <b-modal
            ref="imageModal"
            @shown="loading = false"
            :title="title"
            modal-class="modal-full"
            scrollable
            hide-footer
        >
            <image-grid
                v-if="images"
                :images="images"
                :options="options"
            >
            </image-grid>
        </b-modal>
    </div>
</template>

<script>
import ImageGrid from '../Grid/ImageGrid';

export default {
  name: 'Photo-Viewer',
  components: {
    ImageGrid,
  },
  props: {
    title: {
      default: 'Photos',
    },
    urlKeyBy: {
      default: 'url',
    },
    thumbnailKeyBy: {
      default: 'thumbnail',
    },
    filenameKeyBy: {
      default: 'fileName',
    },
    photoFn: {
      required: true,
    },
    buttonVariant: {
      default: 'yellow',
    },
  },
  data() {
    return {
      loading: false,
      images: [],
      options: {
        movable: false,
        url: 'data-source',
        navbar: false,
      },
    };
  },
  methods: {
    async showModal() {
      this.loading = true;

      try {
        const { data } = await this.photoFn();

        const images = data.data;
        const token = this.$store.getters.authToken;

        images.forEach((image) => {
          image.url = image[this.urlKeyBy];
          image.thumbnail = image[this.thumbnailKeyBy];
          image.fileName = image[this.filenameKeyBy];
        });

        this.images = this.sortByDateSubmitted(images);
      } catch (e) {
        console.log(e);
        this.$notify({
          duration: 7000,
          title: 'An error has occurred',
          text: 'Photos could not be loaded right now. Please try again later',
          type: 'error',
        });
      }

      this.$refs['imageModal'].show();
    },

    /**
     * Sort the row data by filename
     */
    sortByName(images) {
      return images.sort((a, b) => {
        if ((a.fileName).toLowerCase() > (b.fileName).toLowerCase()) {
          return 1;
        }

        if ((b.fileName).toLowerCase() > (a.fileName).toLowerCase()) {
          return -1;
        }

        return 1;
      });
    },

    /**
    * Sort the row data by dataSubmitted
    */
    sortByDateSubmitted(images) {
      return images.sort((a, b) => {
        const dateA = a.dateSubmitted ? new Date(a.dateSubmitted) : new Date(0);
        const dateB = b.dateSubmitted ? new Date(b.dateSubmitted) : new Date(0);

        // First, compare by dateSubmitted
        if (dateA - dateB !== 0) {
          return dateA - dateB;
        }

        // If dates are the same, compare by fileName in ASC order
        const nameA = a.fileName ? a.fileName.toLowerCase() : '';
        const nameB = b.fileName ? b.fileName.toLowerCase() : '';

        if (nameA > nameB) {
          return 1;
        }
        if (nameA < nameB) {
          return -1;
        }

        // If both dateSubmitted and fileName are the same, maintain original order
        return 0;
      });
    }
  },
};
</script>
